import React from "react";
import { Container } from "reactstrap";

import {
  carouselItems,
  LitterIntro,
  LitterPage,
  LitterPuppyGrid,
  ParentPedigree,
  VideoSection
} from "components/Litters/LitterComponents.js";
import SEO from "components/SEO/SEO.js";
import DogGallery from "../dogs/DogGallery";

const announcement = require("../../assets/img/dogs/litters/nj2025/announcement4.jpg");
const dockdiving = require("../../assets/img/dogs/litters/nj2025/dockdiving.jpg");
const agility = require("../../assets/img/dogs/litters/nj2025/agility.jpg");
const flyball = require("../../assets/img/dogs/litters/nj2025/flyball.jpg");
const pedigreeImage = require("../../assets/img/dogs/litters/nj2025/pedigree.jpg");
const jeromeProfile = require("../../assets/img/dogs/profile-jerome.jpg");
const nimonaProfile = require("../../assets/img/dogs/profile-nimona.jpg");
const venusProfile = require("../../assets/img/dogs/profile-venus.jpg");
const venusHopSingAnnouncementImage = require("../../assets/img/dogs/litters/vh2022/announcement.jpg");
const jeromeStack = require("../../assets/img/dogs/litters/nj2025/jerome-stack.jpg");
const nimonaStack = require("../../assets/img/dogs/nimona/stack3.jpg");
const agilityIcon = require("../../assets/img/icon-agility.png");
const dockDivingIcon = require("../../assets/img/icon-dockdiving.png");
const flyballIcon = require("../../assets/img/icon-flyball.png");

const galleryImages = [
  require("../../assets/img/dogs/litters/nj2025/reg1.jpg"),
  require("../../assets/img/dogs/litters/nj2025/reg3.jpg"),
  require("../../assets/img/dogs/litters/nj2025/reg4.jpg"),
  require("../../assets/img/dogs/litters/nj2025/reg6.jpg"),
  require("../../assets/img/dogs/litters/nj2025/reg7.jpg"),
  require("../../assets/img/dogs/litters/nj2025/reg8.jpg"),
  require("../../assets/img/dogs/litters/nj2025/reg10.jpg"),
  require("../../assets/img/dogs/litters/nj2025/reg11.jpg"),
  require("../../assets/img/dogs/litters/nj2025/reg12.jpg"),
  require("../../assets/img/dogs/litters/nj2025/reg14.jpg"),
  require("../../assets/img/dogs/litters/nj2025/reg2.jpg"),
  require("../../assets/img/dogs/litters/nj2025/reg9.jpg"),
  require("../../assets/img/dogs/litters/nj2025/reg5.jpg"),
  require("../../assets/img/dogs/litters/nj2025/reg13.jpg"),
];

const puppyImages = {
  serenity: [
    require("../../assets/img/dogs/litters/nj2025/serenity9.jpg"),
    require("../../assets/img/dogs/litters/nj2025/serenity8.jpg"),
    require("../../assets/img/dogs/litters/nj2025/serenity7.jpg"),
    require("../../assets/img/dogs/litters/nj2025/serenity6.jpg"),
    require("../../assets/img/dogs/litters/nj2025/serenity5.jpg"),
    require("../../assets/img/dogs/litters/nj2025/serenity4.jpg"),
    require("../../assets/img/dogs/litters/nj2025/serenity3.jpg"),
    require("../../assets/img/dogs/litters/nj2025/serenity2.jpg"),
    require("../../assets/img/dogs/litters/nj2025/serenity1.jpg")
  ],
  loyal: [
    require("../../assets/img/dogs/litters/nj2025/loyal9.jpg"),
    require("../../assets/img/dogs/litters/nj2025/loyal8.jpg"),
    require("../../assets/img/dogs/litters/nj2025/loyal7.jpg"),
    require("../../assets/img/dogs/litters/nj2025/loyal6.jpg"),
    require("../../assets/img/dogs/litters/nj2025/loyal5.jpg"),
    require("../../assets/img/dogs/litters/nj2025/loyal4.jpg"),
    require("../../assets/img/dogs/litters/nj2025/loyal3.jpg"),
    require("../../assets/img/dogs/litters/nj2025/loyal2.jpg"),
    require("../../assets/img/dogs/litters/nj2025/loyal1.jpg")
  ],
  luck: [
    require("../../assets/img/dogs/litters/nj2025/luck9.jpg"),
    require("../../assets/img/dogs/litters/nj2025/luck8.jpg"),
    require("../../assets/img/dogs/litters/nj2025/luck7.jpg"),
    require("../../assets/img/dogs/litters/nj2025/luck6.jpg"),
    require("../../assets/img/dogs/litters/nj2025/luck5.jpg"),
    require("../../assets/img/dogs/litters/nj2025/luck4.jpg"),
    require("../../assets/img/dogs/litters/nj2025/luck3.jpg"),
    require("../../assets/img/dogs/litters/nj2025/luck2.jpg"),
    require("../../assets/img/dogs/litters/nj2025/luck1.jpg")
  ],
  hope: [
    require("../../assets/img/dogs/litters/nj2025/hope9.jpg"),
    require("../../assets/img/dogs/litters/nj2025/hope8.jpg"),
    require("../../assets/img/dogs/litters/nj2025/hope7.jpg"),
    require("../../assets/img/dogs/litters/nj2025/hope6.jpg"),
    require("../../assets/img/dogs/litters/nj2025/hope5.jpg"),
    require("../../assets/img/dogs/litters/nj2025/hope4.jpg"),
    require("../../assets/img/dogs/litters/nj2025/hope3.jpg"),
    require("../../assets/img/dogs/litters/nj2025/hope2.jpg"),
    require("../../assets/img/dogs/litters/nj2025/hope1.jpg")
  ]
};

const puppies = [
  {
    name: "Rumi",
    registeredName: "Endgame's Gonna Be Golden",
    images: carouselItems(puppyImages.serenity),
    details: [
      { label: "Litter name", value: "Serenity" },
      { label: "Stats", value: "Female" },
      { label: "Owner", value: "Adriana Nottestad" },
      { label: "Location", value: "NC" },
      { label: "BAER", value: "Normal" },
      { label: "CAER", value: "Normal" }
    ]
  },
  {
    name: "Zinnia",
    registeredName: "Endgame's How It's Done",
    images: carouselItems(puppyImages.loyal),
    details: [
      { label: "Litter name", value: "Loyal" },
      { label: "Stats", value: "Female" },
      { label: "Owner", value: "Lynsey Heffner" },
      { label: "Location", value: "PA" },
      { label: "BAER", value: "Normal" },
      { label: "CAER", value: "Normal" }
    ]
  },
  {
    name: "Tavi",
    registeredName: "Endgame's Fury of Fate",
    images: carouselItems(puppyImages.luck),
    details: [
      { label: "Litter name", value: "Luck" },
      { label: "Stats", value: "Female" },
      { label: "Owner", value: "Grace Heck" },
      { label: "Location", value: "PA" },
      { label: "BAER", value: "Normal" },
      { label: "CAER", value: "Normal" }
    ]
  },
  {
    name: "Radical",
    registeredName: "Endgame's So Rad",
    images: carouselItems(puppyImages.hope),
    details: [
      { label: "Litter name", value: "Hope" },
      { label: "Stats", value: "Female" },
      { label: "Owner", value: "Monica Bush" },
      { label: "Location", value: "AZ" },
      { label: "BAER", value: "Normal" },
      { label: "CAER", value: "Normal" }
    ]
  }
];

const parentHealthSummaries = [
  {
    name: "Jerome",
    breed: "Sport Mix",
    ofaUrl: "https://ofa.org/advanced-search/?appnum=2507854",
    results: [
      { label: "Hips", value: "Cleared of hip dysplasia" },
      { label: "Patellas", value: "Cleared of luxating patellas" },
      { label: "Eyes", value: "Cleared of eye issues" },
      { label: "Elbows", value: "Cleared of elbow dysplasia" },
      { label: "Cardiac", value: "Cleared of cardiac issues" },
      { label: "DNA", value: "Clear of relevant testable diseases" }
    ]
  },
  {
    name: "Nimona",
    breed: "Sport Mix",
    ofaUrl: "https://ofa.org/advanced-search/?appnum=2410937",
    results: [
      { label: "Hips", value: "Cleared of hip dysplasia" },
      { label: "Patellas", value: "Cleared of luxating patellas" },
      { label: "Eyes", value: "Cleared of eye issues" },
      { label: "Shoulders", value: "Cleared of shoulder OCD" },
      { label: "CDDY", value: "Clear through UC Davis" },
      { label: "DNA", value: "Clear of relevant testable diseases" }
    ]
  }
];

const litterUpdates = [
  {
    title: "Agility",
    icon: agilityIcon,
    image: agility,
    imageAlt: "Nimona x Jerome litter agility",
    paragraphs: [
      "All four girls are training for agility and are enjoying their time so far!"
    ]
  },
  {
    title: "Dock Diving",
    icon: dockDivingIcon,
    image: dockdiving,
    imageAlt: "Nimona x Jerome litter dock diving",
    paragraphs: [
      "Rumi and Zinnia have started to compete in dock diving. Rumi's personal best is 21'9 and is currently ranked 20th for lap dogs. Zinnia did her first event with her owner who also participated for the first time and got a personal best of 18'3.",
    ]
  },
  {
    title: "Flyball",
    icon: flyballIcon,
    image: flyball,
    imageAlt: "Nimona x Jerome litter flyball",
    paragraphs: [
      "Rumi is training for flyball. She will run on That's So Fetch.",
    ]
  }
];

function NJ2025Page() {
  return (
    <>
      <SEO
        title="Nimona × Jerome 2025 | Sport Mix Puppies"
        description="See the Nimona x Jerome 2025 sport mix puppies from Endgame Sport Dogs near Raleigh NC, including puppy profiles, health results, parent information, and agility, flyball, dock diving, and disc videos."
        path="/litters/nimona-jerome-2025"
      />
      <LitterPage
        headerBg="nj2025"
        pageClassName="litter-detail-page litter-detail-page-modern"
        footerVariant="dark"
      >
        <section className="litter-detail-section litter-overview-section">
          <Container>
            <LitterIntro
              title="Nimona × Jerome"
              eyebrow="Sport Mix Litter - 2025"
              announcement={announcement}
              announcementAlt="Jerome x Nimona litter announcement"
              finalCopy={
                <p>
                  For more information about <a className="litter-inline-link" href="/dogs/nimona">Nimona</a>, view her individual page. For more information on Jerome, contact Morgan Jarvis or reach out to me if you would like to learn about this cross.
                </p>
              }
              healthParents={parentHealthSummaries}
              overviewCopy={
                <>
                  <p>Jerome is a well rounded, multi mix sport dog from Tactical Image in Canada. He was third in finals at the UKI invitational in 2024 and made the IFCS agility team in Canada for 2025. He has a flyball pb of 3.6 and was on the 4th place regular team at Canam in 2024. His father has been on many world teams and has won at multiple national events. His mother is in the lap dogs hall of fame in Dock Dogs and has a pb of 28'2. She also played flyball and has a pb of 3.62. Jerome has siblings and relatives are also doing well in a variety of sports including setting sub 4 times in flyball, making podiums in agility, and holding records in disc. He is neutral with strangers, well behaved in public, and performs in trick shows for large crowds. Both him and Nimona have a great off switch inside the house and are very high drive when working.</p>
                  <p>I'm expecting this breeding to produce high drive puppies who will thrive in experienced sport homes. I will consider intermediate level handlers who are looking for a competitive dog. Jerome competes in agility, flyball, dock diving, disc and obedience. Nimona competes in flyball, agility, disc, dock diving, and barn hunt. Preference will be for agility and/or flyball focused homes.</p>
                  <p>Jerome and Nimona are clear of all testable diseases that would affect the breeds that make up their mixes. Nimona has been additionally cleared for CDDY by UC Davis laboratory. They both have been cleared of hip dysplasia, luxating patellas, and eye issues. Nimona has also been cleared of shoulder OCD. Jerome has been cleared of elbow dysplasia and cardiac issues. He is 16.6" tall and 22lbs. Nimona is 15.75" tall and 20lbs. The estimated breed breakdown of the puppies is: 43% border collie, 33% jack russell, 14% whippet, 7% staffie, 3% border terrier. There is a possibility for smooth or rough coats. I expect puppies to range in size from 15"-17" but multigenerational mixes may be a little smaller or taller. BAER, CAER, and Embark testing will be done before the puppies go home.</p>
                </>
              }
              variant="modern"
            />
            <ParentPedigree
              className=""
              parents={[
                { name: "Jerome", breed: "Sport Mix", image: jeromeProfile },
                {
                  name: "Nimona",
                  breed: "Sport Mix",
                  image: nimonaProfile,
                  href: "/dogs/nimona",
                  litter: {
                    label: "Venus × Hop Sing 2022",
                    href: "/litters/venus-hopsing-2022",
                    image: venusHopSingAnnouncementImage
                  }
                }
              ]}
              pedigree={{
                image: pedigreeImage,
                href: "https://dogs.pedigreeonline.com/tactical-images-jeromes-got-game-Jqk6wgV4/pedigree?hypomating=endgames-im-a-shark-EOsL8TTj",
                linkedDogs: [
                  {
                    id: "/dogs/venus",
                    name: "Venus",
                    relationship: "Granddam",
                    breed: "Border Collie",
                    image: venusProfile,
                    profileHref: "/dogs/venus"
                  }
                ]
              }}
              variant="modern"
            />
          </Container>
        </section>

        <section className="litter-detail-section litter-stack-section site-bg-light-blue">
          <Container>
            <div className="litter-detail-section-heading">
              <h2>Parent Stacks</h2>
              <span className="dog-detail-heading-line" aria-hidden="true"></span>
            </div>
            <div className="litter-stack-grid">
              <img alt="Jerome stack" src={jeromeStack} />
              <img alt="Nimona stack" src={nimonaStack} />
            </div>
          </Container>
        </section>

        <section className="litter-detail-section litter-media-section site-bg-dark-navy">
          <Container>
            <VideoSection
              title="Parent Videos"
              className=""
              variant="modern"
              videos={[
                { src: "https://www.youtube.com/embed/6uW-raxdnjw?si=3h72Isk9tvIWTTsG", caption: "Nimona - Sport Video" },
                { src: "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fendgamesportdogs%2Fvideos%2F1089030808818866%2F&show_text=false&width=560&t=0", caption: "Nimona - Sport Video" },
                { src: "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fmorgan.jarvis.18%2Fvideos%2F1967448656964732%2F&show_text=false&width=560&t=0", caption: "Jerome - Sport Video" },
                { src: "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fmorgan.jarvis.18%2Fvideos%2F435274972318100%2F&show_text=false&width=560&t=0", caption: "Jerome - Sport Video" }
              ]}
            />
          </Container>
          <Container className="padding-header">
            <VideoSection
              title="Related Dogs"
              className=""
              variant="modern"
              videos={[
                { src: "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fendgamesportdogs%2Fvideos%2F751541700434377%2F&show_text=false&width=560&t=0", caption: "Chibiusa (Nimona's littermate)" },
                { src: "https://www.facebook.com/plugins/video.php?height=323&href=https%3A%2F%2Fwww.facebook.com%2Fendgamesportdogs%2Fvideos%2F7537694036243530%2F&show_text=false&width=560&t=0", caption: "Cinco (Nimona's littermate)" },
                { src: "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fmorgan.jarvis.18%2Fvideos%2F279431501648046%2F&show_text=false&width=560&t=0", caption: "Tension (Repeat breeding Qwik x Image)" },
                { src: "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fmorgan.jarvis.18%2Fvideos%2F814918330480365%2F&show_text=false&width=560&t=0", caption: "Qwik (Jerome's father)" }
              ]}
            />
          </Container>
        </section>

        <LitterPuppyGrid
          summary="Nimona gave birth to 4 puppies on September 6th, 2025. The litter theme was Labubu/The Monsters - Big Into Energy."
          puppies={puppies}
          variant="modern"
        />

        <section className="litter-detail-section litter-updates-section">
          <Container>
            <div className="litter-detail-section-heading">
              <h2>Litter Updates</h2>
              <span className="dog-detail-heading-line" aria-hidden="true"></span>
            </div>
            <div className="litter-update-list">
              {litterUpdates.map(update => {
                return (
                  <article className="litter-update-item" key={update.title}>
                    <div className="litter-update-icon" aria-hidden="true">
                      <img alt="" src={update.icon} />
                    </div>
                    <div className="litter-update-copy">
                      <h3>{update.title}</h3>
                      {update.paragraphs.map(paragraph => (
                        <p key={paragraph}>{paragraph}</p>
                      ))}
                    </div>
                    <img className="litter-update-image" alt={update.imageAlt} src={update.image} />
                  </article>
                );
              })}
            </div>
          </Container>
        </section>

        <section className="litter-detail-section litter-media-section litter-group-video-section itter-detail-section litter-gallery-section dog-gallery-section site-bg-dark-navy">
          <Container>
            <VideoSection
              title="Litter Videos"
              className=""
              variant="modern"
              videos={[
                { src: "https://www.youtube.com/embed/pCK8wSTN7EQ", caption: "11 months - Tavi, Zinnia, Rad, Rumi" }
              ]}
            />
            <div className="padding-header litter-detail-section-heading litter-detail-section-heading-left">
              <h2>Photo album</h2>
              <span className="dog-detail-heading-line" aria-hidden="true"></span>
            </div>
            <DogGallery images={galleryImages} reverseImages />
          </Container>
        </section>
      </LitterPage>
    </>
  );
}

export default NJ2025Page;
